import useSWR from 'swr'
import { useRecoilState } from 'recoil'
import { browserBackState, BrowserBackState } from '~/src/recoil'
import { wishListRepository } from '~/src/repositories'
import { IWishListParams } from '~/src/repositories/WishList/models/WishList'

export const useWishListHooks = (queryParams: IWishListParams | undefined) => {
  const [, setBrowserBackStateAtom] = useRecoilState<BrowserBackState>(browserBackState)
  const {
    data: wishList,
    error: wishListError,
    mutate: wishListMutate,
  } = useSWR(['/wish-lists', queryParams], () => wishListRepository.getWishLists(queryParams))

  return {
    wishList,
    wishListError,
    wishListMutate,
    setBrowserBackStateAtom,
  }
}
